

const TransactionManager = function (payload) {
    this.transactions = payload.transactions;
    this.clusterlets = payload.clusterlets;
    this.events = payload.events;
    this.messages = payload.messages || [];
    this.fields = payload.fields || [];
}


TransactionManager.prototype.getNestedEvents = function (nestedTransactions) {
    try {
        let nestedEvents = [];
        nestedTransactions.forEach(ntr => {
            let nestedTransaction = this.transactions.find(tr => tr._id == ntr.id);
            if (nestedTransaction) {
                nestedEvents = [...nestedEvents, ...nestedTransaction.events];
            }
        });

        return nestedEvents;
    } catch (error) {
        throw error;
    }
}

TransactionManager.prototype.generateEventPayload = function (event) {

    if (this.fields === undefined)
        return []

    let defaultMandatoryFields = this.fields.filter(fd => fd.parent[0].id == event.message && fd.attributes.default != undefined && (fd.attributes.optional == undefined || fd.attributes.optional == false))


    let selectedFileds = defaultMandatoryFields.map(item => {
        let payload = {
            field: item.name,
            type: item.attributes.type,
            value: item.attributes.default
        }
        return payload
    })

    return selectedFileds;
    return []

}

TransactionManager.prototype.getAllTransactionEvents = function (transactionId) {
    try {

        const transactionData = this.transactions.find(tr => tr._id == transactionId);
        const nestedEvents = this.getNestedEvents(transactionData.nestedTransactions);
        const transactionEvents = [...transactionData.events, ...nestedEvents];

        const modifiedevents = transactionEvents.map(trEvent => {

            const eventData = JSON.parse(JSON.stringify(this.events.find(ele => ele._id == trEvent.id)))
            eventData.order = trEvent.order;

            let eventFileds = this.generateEventPayload(eventData)

            if (eventFileds.length > 0) {
                eventData.payload = eventFileds
            }

            return eventData;
        }).filter(item => item !== undefined).sort((a, b) => a.order - b.order);
        return modifiedevents;
    } catch (error) {
        throw error;
    }
}

TransactionManager.prototype.getTriggeringEvent = function (transactionId) {
    try {

        const transactionData = this.transactions.find(tr => tr._id == transactionId);
        const firstEvent = transactionData?.events?.sort((a, b) => a.order - b.order)[0];
        const firstEventData = firstEvent != undefined ? this.events.find(ev => ev._id === firstEvent.id) : null;
        return firstEventData;
        
    } catch (error) {
        throw error;
    }
}



TransactionManager.prototype.generateAllResponseEvents = function (transactionId) {
    try {
        // console.log("generateAllResponseEvents-------------", transactionId)
        if (!transactionId) {
            return [];
        }
        const allTransactionEvents = this.getAllTransactionEvents(transactionId);

        if (!Array.isArray(allTransactionEvents) || !Array.isArray(this.clusterlets)) {
            return [];
        }  

        const delegates = this.clusterlets.filter(item => item.type === 1).map(item => item._id)
        const firstEventData = this.getTriggeringEvent(transactionId);

        if (!firstEventData || firstEventData.src === undefined) {
            return [];
        }

        const responseEvents = allTransactionEvents.filter(item => {
            return delegates.includes(item.dst) && firstEventData.src === item.dst;
        });

        return responseEvents;
    } catch (error) {
        console.error(`Finding response events failed. `, error);
        throw error;
    }
}

TransactionManager.prototype.generateResponseEventMessages = function (transactionId) {
    try {
        console.log("generateResponseEventMessages----------------------", transactionId)
        let responseEvents = this.generateAllResponseEvents(transactionId)
        console.log({responseEvents})

        const responseMessages = responseEvents.map(item => item.message)

        const responseEventMessages = this.messages.filter(item => responseMessages.includes(item._id))

        return responseEventMessages

    } catch (error) {
        throw error;
    }
}




export default TransactionManager;